import { InjectionToken } from "@angular/core";

export const SPECIFIC_LIVE_ORGANIZATION_TOKEN_LIST: InjectionToken<number[]> = new InjectionToken<number[]>('ORGANIZATION_ID_LIST');
